// Import global declaration for projects consuming this package
/// <reference types="./global" />
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { initDatadogRum } from './features/datadog';

export function init() {
  const el = document.getElementById('root');

  if (!el) {
    throw new Error('root element not found');
  }

  const root = createRoot(el);
  root.render(<App />);
}

if (process.env.NODE_ENV !== 'production') {
  new EventSource('/esbuild').addEventListener('change', () =>
    window.location.reload(),
  );
}

init();
initDatadogRum();

export default App;
